import httpUtil from "@/utils/httpUtil";

export const selectLogBatchList = params => httpUtil.get("/storeLogBatch", params);
export const selectCodeList = params => httpUtil.get("/storeLogBatch/codeList", params);
export const selectLogDetail = params => httpUtil.get("/storeLogBatch/logDetail", params);
export const exportExcle = params => httpUtil.get("/storeLogBatch/export", params);
export const back = params => httpUtil.get("/storeLogBatch/back", params);




